import { render, staticRenderFns } from "./DeleteAccountModal.vue?vue&type=template&id=36819b1f&scoped=true&"
import script from "./DeleteAccountModal.vue?vue&type=script&lang=js&"
export * from "./DeleteAccountModal.vue?vue&type=script&lang=js&"
import style0 from "./DeleteAccountModal.vue?vue&type=style&index=0&id=36819b1f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36819b1f",
  null
  
)

export default component.exports